import store from 'redux/store'

export const TEMPLATE_NOT_FOUND = ''
export const TEMPLATE_ERROR = 'TEMPLATE_ERROR'

/**
 * Compile template
 * @param {string} key template key
 * @param {object} data data for compiling template
 * @param {boolean} withoutProcessing when true data is processed
 * @returns {string} translated string
 */
const t = (key, data = {}, withoutProcessing = false) => {
  try {
    let { templateState: { map } } = store.getState()

    if (process.env.NODE_ENV === 'test') return key

    let mapValue = map[key]

    if (withoutProcessing) return mapValue

    if (mapValue === undefined && Object.values(map).length > 0) {
      console.error(`template ${key} not found`)
      return key
    }

    return template(mapValue, data)
  } catch (error) {
    console.error(`template ${key}(${JSON.stringify(data)}) error: ${error}`)
    return TEMPLATE_ERROR
  }
}

// Simple JavaScript Templating
// John Resig - https://johnresig.com/ - MIT Licensed
const templateCache = {}
/* eslint-disable */
export const template = (str = '', data = {}) => {
  // Figure out if we're getting a template, or if we need to
  // load the template - and be sure to cache the result.

  // Generate a reusable function that will serve as a template
  // generator (and which will be cached).
  const tmpl = str + JSON.stringify(data)
  const fn = templateCache[tmpl] ?
    templateCache[tmpl] :
    new Function("obj",
      "var p=[],print=function(){p.push.apply(p,arguments);};" +

      // Introduce the data as local variables using with(){}
      "with(obj){p.push('" +

      // Convert the template into pure JavaScript
      str
        .replace(/_template\(/g, "this.t(")
        .replace(/[\r\t\n]/g, " ")
        .split("<%").join("\t")
        .replace(/((^|%>)[^\t]*)'/g, "$1\r")
        .replace(/\t-(.*?)%>/g, "',$1 && $1.toString(),'")
        .replace(/\t=(.*?)%>/g, "',$1,'")
        .split("\t").join("');")
        .split("%>").join("p.push('")
        .split("\r").join("\\'")
      + "');}return p.join('');"
    );
  if (!templateCache[tmpl]) {
    templateCache[tmpl] = fn
  }
  // Provide some basic currying to the user
  return fn.call({ 't': t }, data)
};
/* eslint-enable */

export default t
